import { useEffect, useState } from "react";
import {
  Sheet, SheetContent, SheetHeader, SheetTitle, SheetDescription, SheetFooter,
} from "../components/ui/sheet";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { Button } from "../components/ui/button";
import {
  Select, SelectContent, SelectItem, SelectTrigger, SelectValue,
} from "../components/ui/select";

const EMPTY = {
  azienda: "", rivenditore: "", agente: "", modello: "", finitura: "",
  tipologia: "", modello_living: "", data_sviluppata: "", data_definita: "",
  prende_posto_di: "", stato: "In sviluppo",
};

const inputCls = "rounded-none border-neutral-200 focus-visible:ring-0 focus-visible:border-neutral-900 h-10";
const labelCls = "text-xs uppercase tracking-[0.1em] text-neutral-500";

const Field = ({ label, children }) => (
  <div className="space-y-1.5">
    <Label className={labelCls}>{label}</Label>
    {children}
  </div>
);

export default function KitchenForm({ open, onOpenChange, initial, onSave, saving }) {
  const [form, setForm] = useState(EMPTY);

  useEffect(() => {
    if (open) setForm(initial ? { ...EMPTY, ...initial } : EMPTY);
  }, [open, initial]);

  const set = (k, v) => setForm((f) => ({ ...f, [k]: v }));

  const submit = (e) => {
    e.preventDefault();
    const { id, ...payload } = form;
    onSave(payload, initial?.id);
  };

  return (
    <Sheet open={open} onOpenChange={onOpenChange}>
      <SheetContent className="w-full sm:max-w-lg overflow-y-auto rounded-none border-l border-neutral-200 bg-white p-0" data-testid="kitchen-form-sheet">
        <SheetHeader className="p-6 border-b border-neutral-200 text-left">
          <SheetTitle className="font-head text-2xl font-light tracking-tight">
            {initial ? "Modifica cucina" : "Nuova cucina"}
          </SheetTitle>
          <SheetDescription className="text-neutral-500">
            Compila i dettagli dell'esposizione.
          </SheetDescription>
        </SheetHeader>

        <form onSubmit={submit} className="p-6 space-y-5">
          <div className="grid grid-cols-2 gap-4">
            <Field label="Azienda">
              <Input data-testid="form-azienda" className={inputCls} value={form.azienda} onChange={(e) => set("azienda", e.target.value)} />
            </Field>
            <Field label="Rivenditore">
              <Input data-testid="form-rivenditore" className={inputCls} value={form.rivenditore} onChange={(e) => set("rivenditore", e.target.value)} />
            </Field>
          </div>

          <div className="grid grid-cols-2 gap-4">
            <Field label="Agente">
              <Input data-testid="form-agente" className={inputCls} value={form.agente} onChange={(e) => set("agente", e.target.value)} />
            </Field>
            <Field label="Modello">
              <Input data-testid="form-modello" className={inputCls} value={form.modello} onChange={(e) => set("modello", e.target.value)} />
            </Field>
          </div>

          <div className="grid grid-cols-2 gap-4">
            <Field label="Finitura">
              <Input data-testid="form-finitura" className={inputCls} value={form.finitura} onChange={(e) => set("finitura", e.target.value)} />
            </Field>
            <Field label="Tipologia">
              <Select value={form.tipologia} onValueChange={(v) => set("tipologia", v)}>
                <SelectTrigger data-testid="form-tipologia" className={inputCls + " bg-white"}>
                  <SelectValue placeholder="Seleziona" />
                </SelectTrigger>
                <SelectContent className="rounded-none bg-white border-neutral-200">
                  {["Lineare", "Angolare", "Penisola", "Isola"].map((t) => (
                    <SelectItem key={t} value={t} className="rounded-none">{t}</SelectItem>
                  ))}
                </SelectContent>
              </Select>
            </Field>
          </div>

          <Field label="Modello Living">
            <Input data-testid="form-living" className={inputCls} value={form.modello_living} onChange={(e) => set("modello_living", e.target.value)} />
          </Field>

          <div className="grid grid-cols-2 gap-4">
            <Field label="Data Sviluppata">
              <Input data-testid="form-data-sviluppata" type="date" className={inputCls} value={form.data_sviluppata} onChange={(e) => set("data_sviluppata", e.target.value)} />
            </Field>
            <Field label="Data Definita">
              <Input data-testid="form-data-definita" type="date" className={inputCls} value={form.data_definita} onChange={(e) => set("data_definita", e.target.value)} />
            </Field>
          </div>

          <Field label="Prende il posto di">
            <Input data-testid="form-prende-posto" className={inputCls} value={form.prende_posto_di} onChange={(e) => set("prende_posto_di", e.target.value)} placeholder="Modello sostituito" />
          </Field>

          <Field label="Stato">
            <Select value={form.stato} onValueChange={(v) => set("stato", v)}>
              <SelectTrigger data-testid="form-stato" className={inputCls + " bg-white"}>
                <SelectValue />
              </SelectTrigger>
              <SelectContent className="rounded-none bg-white border-neutral-200">
                {["In sviluppo", "Definita", "Esposta"].map((s) => (
                  <SelectItem key={s} value={s} className="rounded-none">{s}</SelectItem>
                ))}
              </SelectContent>
            </Select>
          </Field>

          <SheetFooter className="pt-4 flex-row gap-3">
            <Button type="button" variant="outline" className="rounded-none flex-1 border-neutral-300" onClick={() => onOpenChange(false)}>
              Annulla
            </Button>
            <Button data-testid="form-save-button" type="submit" disabled={saving} className="rounded-none flex-1 bg-[#B4654A] hover:bg-[#98553E] text-white">
              {saving ? "Salvataggio…" : "Salva"}
            </Button>
          </SheetFooter>
        </form>
      </SheetContent>
    </Sheet>
  );
}
